module.exports = {"id":"190494","name":"Daniel Opare","rating":"73","photo":"./data/images/photos/0/190494.png","club":{"name":"FC Augsbourg","logo":"./data/images/clubs/FCAugsbourg.png"},"positions":["DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielOpare0.json
// module id = 936
// module chunks = 0